import { FontSpec } from 'chart.js';
import { isBreakpoint, theme } from '../../theme';
import { VoteType } from './types';

export function getChartFont(): Partial<FontSpec> {
  return {
    family: theme.font.family,
    size: getFontSize(),
    weight: '400',
  };
}

export function getVoteColor(voteType: VoteType): string {
  switch (voteType) {
    case 'FAVOUR':
      return '#C4F27D';
    case 'AGAINST':
      return '#F95959';
    case 'ABSTAIN':
      return '#7A7C88';
    case 'NO_VOTE':
      return '#9E7BF4';
    case 'ABSENT':
      return '#5168FF';
    case 'INVALID':
      return '#FFEC6F';
    default:
      return '';
  }
}

function getFontSize() {
  let fontSize = 14;

  if (isBreakpoint('small')) {
    fontSize = 16;
  }

  if (isBreakpoint('medium')) {
    fontSize = 18;
  }

  return fontSize;
}
